
function SdSearchInputCtrl($window, TranslationService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.search = function () {
        setTimeout(ctrl.onSearch);
    }
}

SdSearchInputCtrl.$inject = ['$window', 'TranslationService'];

seedWebApp.component('sdSearchInput', {
    controller: SdSearchInputCtrl,
    bindings: {
        filterString: '=',
        itemsLoaded: '=',
        itemsTotal: '=',
        onSearch: '<',
        itemsCount: '<'
    },
    templateUrl: '/SPA/Components/sd-search-input.html'
});